class GeneralApiErrorResponse {
  name: string;

  constructor() {
    this.name = "GeneralApiErrorResponse";
  }
}

export default GeneralApiErrorResponse;
